export function bindExternalAddSellerUser() {
    BindAccountForms(function (form) {
        const isBuyer = form.find(".hidIsBuyer").val() === "True";
        const isInvitingSellerActive = form.find(".hidIsInvitingSellerActive").val() === "True";
        const isInvitingSellerUserDomainPublic = form.find(".hidIsInvitingSellerUserDomainPublic").val() === "True";
        const invitingSellerDomain = form.find(".hidInvitingSellerDomain").val();
        form.on("change", ".addedUserEmail", function () {
            form.find(".serverErrors").remove();
        });
        form.on("click", ".btnSubmit", function (event) {
            var elem = $(event.target);
            event.preventDefault();
            const addedUserEmail = form.find(".addedUserEmail").val();
            const isDomainsEqual = compareEmailDomains(invitingSellerDomain, addedUserEmail);
            const shouldShowMessage = !isBuyer && isInvitingSellerActive && (isInvitingSellerUserDomainPublic || (!isInvitingSellerUserDomainPublic && !isDomainsEqual));
            if (addedUserEmail != "" && shouldShowMessage) {
                showMsg({
                    msg: elem.attr("popUpMsg"),
                    messageType: showMsg.MsgTypeYesNo,
                    onMsgYesBtnFunc: () => {
                        form.trigger("submit");
                    },
                    isHtml: true,
                    closeWhenClickingYes: true,
                    closeWhenClickingNo: true
                });
            } else {
                form.trigger("submit");
            }
        });

    }, {
        formSelector: $("#addSellerUserForm"),
        onSuccess: showValidationErrorsOrInvokeSuccessFunc(function (ret, statusText, xhr, jqForm) {
            jqForm.closest(".addSellerUserContainer").html(ret);
        })
    });
};

function compareEmailDomains(invitingSellerDomain, addedUserEmail) {
    if (!invitingSellerDomain || !addedUserEmail) {
        return false;
    }
    const emailParts = addedUserEmail.split('@');
    if (emailParts.length !== 2) {
        return false;
    } 
    const emailDomain = '@' + emailParts[1].toLowerCase().trim();
    const inviteDomain = invitingSellerDomain.toLowerCase().trim();

    return inviteDomain === emailDomain;
}
